// extracted by mini-css-extract-plugin
export default {"wrapper":"category_card_wrapper__hdWui","not_post":"category_card_not_post__pGNcU","imgQuiz":"category_card_imgQuiz__RMZgF"};